import * as errorStrings from "../../enums/errorStrings";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

export function UnauthenticatedRoute({
	component,
	render,
	isAuthenticated = false,
	isAuthSuspended = false,
	...rest
}) {
	if (!component && !render) {
		throw new Error(errorStrings.INVALID_ROUTE_PROPERTIES);
	}

	return (
		<Route
			{...rest}
			// eslint-disable-next-line react/jsx-no-bind
			render={(innerProps) => {
				if (isAuthSuspended || !isAuthenticated) {
					return component
						? React.createElement(component, innerProps)
						: render(innerProps);
				}

				return <Redirect to={{ ...innerProps.location, pathname: "/" }} />;
			}}
		/>
	);
}

UnauthenticatedRoute.propTypes = {
	component: PropTypes.func,
	isAuthenticated: PropTypes.bool,
	isAuthSuspended: PropTypes.bool,
	render: PropTypes.func,
};

const mapStateToProps = (state) => ({
	isAuthenticated: state.session.isAuthenticated,
	isAuthSuspended: state.session.isPageAuthSuspended,
});

export default connect(mapStateToProps)(UnauthenticatedRoute);
